import React from 'react';

import { number, bool, func } from 'prop-types';

import chevronLeft from 'assets/chevron-left.svg';
import chevronRight from 'assets/chevron-right.svg';

import './Pagination.scss';

const BASE_RANGE = [1, 2, 3, 4, 5, 6, 7];

function computeRangeToDisplay(currentPage, totalPageCount) {
  if (totalPageCount < 7) {
    return BASE_RANGE.filter(n => n <= totalPageCount);
  }

  if (currentPage < 5) {
    return BASE_RANGE;
  }

  if (currentPage > totalPageCount - 5) {
    return BASE_RANGE.map(n => totalPageCount - (BASE_RANGE.length - n));
  }

  return [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2];
}

function Page({ num, isActive, onPageChange }) {
  return (
    <div
      className={`Pagination__page ${isActive ? 'active' : ''}`}
      onClick={() => {
        onPageChange(num);
      }}
    >
      {num}
    </div>
  );
}

Page.propTypes = {
  num: number.isRequired,
  isActive: bool.isRequired,
  onPageChange: func.isRequired,
};

export default function Pagination({ onPageChange, totalItems, currentPage, itemsPerPage }) {
  const totalPageCount = Math.ceil(totalItems / itemsPerPage);
  const rangeToDisplay = computeRangeToDisplay(currentPage, totalPageCount);

  if (totalPageCount === 1) return null;

  return (
    <div className="Pagination">
      <div
        className="Pagination__page"
        onClick={() => {
          if (currentPage !== 1) {
            onPageChange(currentPage - 1);
          }
        }}
      >
        <img alt="Previous" src={chevronLeft} />
      </div>

      {!rangeToDisplay.includes(1) && (
        <Page num={1} isActive={currentPage === 1} onPageChange={onPageChange} />
      )}
      {!rangeToDisplay.includes(2) && (
        <div className="Pagination__page Pagination__points">...</div>
      )}

      {rangeToDisplay.map(num => (
        <Page key={num} num={num} isActive={currentPage === num} onPageChange={onPageChange} />
      ))}

      {!rangeToDisplay.includes(totalPageCount - 1) && (
        <div className="Pagination__page Pagination__points">...</div>
      )}
      {!rangeToDisplay.includes(totalPageCount) && (
        <Page
          num={totalPageCount}
          isActive={currentPage === totalPageCount}
          onPageChange={onPageChange}
        />
      )}

      <div
        className="Pagination__page"
        onClick={() => {
          if (currentPage !== totalPageCount) {
            onPageChange(currentPage + 1);
          }
        }}
      >
        <img alt="Next" src={chevronRight} />
      </div>
    </div>
  );
}

Pagination.propTypes = {
  currentPage: number.isRequired,
  totalItems: number,
  itemsPerPage: number.isRequired,
  onPageChange: func.isRequired,
};

Pagination.defaultProps = {
  totalItems: 0,
};
